import React, { useEffect, useState } from 'react';
import { HashRouter, BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { message } from 'antd';
import Layout from './components/Layout';

import ACCPBossScreen from 'app/screens/ACCPBossScreen';
import ACCPSupervisorScreen from 'app/screens/ACCPSupervisorScreen';
import AdministrativeRepresentativeScreen from 'app/screens/AdministrativeRepresentativeScreen';
import BookmarksScreen from 'app/screens/BookmarksScreen';
import BrowserMessageScreen from 'app/screens/BrowserMessageScreen';
import ClientProcedureScreen from 'app/screens/ClientProcedureScreen';
import ClientReportScreen from 'app/screens/ClientReportScreen';
import CommunicationProgramScreen from 'app/screens/CommunicationProgramScreen';
import CommunicationScreen from 'app/screens/CommunicationScreen';
import CommunicationStatusScreen from 'app/screens/CommunicationStatusScreen'
import CommunicationsViewer from './app/screens/CommunicationsViewerScreen/CommunicationsViewerScreen';
import CompanyScreen from 'app/screens/CompanyScreen';
import ComplianceAdvanceScreen from 'app/screens/ComplianceAdvanceScreen';
import KeyUserAdvanceScreen from 'app/screens/KeyUserAdvanceScreen';
import CourseScreen from './app/screens/ScheduledProcedureScreen/ScheduledProcedureScreen';
import DashboardScreen from 'app/screens/DashboardScreen/DashboardScreen';
import EmployeeDashboardScreen from './app/screens/EmployeeDashboardScreen/EmployeeDashboardScreen';
import EvaluationsScreen from 'app/screens/EvaluationsScreen';
import HomologousProcedureScreen from 'app/screens/HomologousProcedureScreen';
import Login from './app/screens/LoginScreen/LoginScreen';
import ManagementReportScreen from 'app/screens/ManagementReportScreen';
import NavMenu from '../src/components/NavMenu';
import NotFoundScreen from 'app/screens/NotFoundScreen';
import PEPRepresentativeScreen from 'app/screens/PEPRepresentativeScreen';
import ProcessScreen from 'app/screens/ProcessScreen';
import SSPARepresentativeScreen from 'app/screens/SSPARepresentativeScreen';
import SpecialtyScreen from 'app/screens/SpecialtyScreen';
import TechnicalRepresentativeScreen from 'app/screens/TechnicalRepresentativeScreen';
import WorkCycleEvaluationScreen from 'app/screens/WorkCycleEvaluationScreen';
import WorkCycleScreen from 'app/screens/WorkCycleScreen';
import TrainingScreen from 'app/screens/TrainingScreen/TrainingScreen';
import SystemScreen from 'app/screens/SystemScreen/SystemScreen';
import UserSearchScreen from "app/screens/UserSearchScreen/UserSearchScreen";
import HistoryCompaignScreen from 'app/screens/HistoryCompaignScreen/HistoryCompaignScreen';
import DailyComplianceScreen from 'app/screens/DailyComplianceScreen/DailyComplianceScreen';
import ComplianceMatrixbyPositionScreen from 'app/screens/ComplianceMatrixbyPositionScreen/ComplianceMatrixbyPositionScreen';
import CommunicationProgramComplianceScreen from 'app/screens/ReportCommunicationProgramScreen/ReportCommunicationProgramScreen'
import OnSiteEvaluationsScreen from './app/screens/OnSiteEvaluationsScreen/OnSiteEvaluationsScreen';
import CotplayHubScreen from 'app/screens/CotplayHubScreen';
import SignatureScreen from './app/screens/SignatureScreen';
import DiplomaScreen from 'app/screens/DiplomaScreen/DiplomaScreen'
import DailyAttentionGraphsScreen from 'app/screens/DailyAttentionGraphsScreen/DailyAttentionGraphsScreen';
import CommunicationEvaluationGraphsScreen from 'app/screens/CommunicationEvaluationGraphsScreen/CommunicationEvaluationGraphsScreen'
import ListadoKeyUserScreen from 'app/screens/ListadoKeyUserScreen/ListadoKeyUserScreen'
import KUCatalogueScreen from 'app/screens/KUCatalogue'
import { fetchGetProcessMatrix, setLoadingDownloadRepot, setPercentDownloadReport } from './app/actions/ComplianceMatrixbyPositionActions'
import { IDMScreen } from 'app/reducers'
import { PersistGate } from 'redux-persist/integration/react'
import { persistor } from '../src/store/Store'
import { ProtectedRoute } from './config/ProtectedRoute';
import { useSelector, useDispatch } from 'react-redux'
import { useSignalR } from './app/hooks/useSignalR'
import ApiService from 'app/services/ApiService';

const components = {
    Login,
    CourseScreen,
    CommunicationsViewer,
    DashboardScreen,
    EvaluationsScreen,
    WorkCycleScreen,
    NavMenu,
    CotplayHubScreen,
    CommunicationScreen,
    EmployeeDashboardScreen,
    WorkCycleEvaluationScreen,
    CommunicationStatusScreen,
    CommunicationProgramScreen,
    ComplianceAdvanceScreen,
    KeyUserAdvanceScreen,
    NotFoundScreen,
    BookmarksScreen,
    SpecialtyScreen,
    CompanyScreen,
    ClientProcedureScreen,
    HomologousProcedureScreen,
    TechnicalRepresentativeScreen,
    AdministrativeRepresentativeScreen,
    SSPARepresentativeScreen,
    PEPRepresentativeScreen,
    ACCPSupervisorScreen,
    ClientReportScreen,
    ACCPBossScreen,
    ProcessScreen,
    ManagementReportScreen,
    BrowserMessageScreen,
    TrainingScreen,
    SystemScreen,
    UserSearchScreen,
    HistoryCompaignScreen,
    DailyComplianceScreen,
    ComplianceMatrixbyPositionScreen,
    CommunicationProgramComplianceScreen,
    OnSiteEvaluationsScreen,
    SignatureScreen,
    DiplomaScreen,
    CommunicationProgramComplianceScreen,
    DailyAttentionGraphsScreen,
    CommunicationEvaluationGraphsScreen,
    ListadoKeyUserScreen,
    KUCatalogueScreen
}

export default () => {

    // const { employeeId } = useSelector(state => state.Auth.employeeById)
    const { employeeById } = useSelector(state => state.Auth)
    const {
        item
    } = useSelector(state => state.Auth)

    const dispatch = useDispatch();

    const authScreen = useSelector(IDMScreen);
    const isIE = false || !!document.documentMode;
    const isEdge = !isIE && !!window.StyleMedia;

    const { socket, online } = useSignalR(`${process.env.REACT_APP_API_ERAPIDS}api/generalhub`)

    const handleLoad = async () => {
        if (item.User.IdCompany) {
            const employeeId = item.User.IdCompany;

            // const result = await ApiService.GetProcessMatrix(employeeId)
            // if (result.data) {
            //     const { fileName, finish, idEmployee, message, regCreationDate, url } = result.data
            //     //existe un processo corriendo
            //     if (employeeId === idEmployee) {
            //         dispatch(setLoadingDownloadRepot({
            //             finish: finish,
            //             message: message,
            //             fileName: fileName,
            //             url: url,
            //             idEmployee: idEmployee,
            //             regCreationDate: regCreationDate
            //         }))
            //     }
            // }
        }
    }

    useEffect(() => {
        if (item.IsAuthenticated) {
            handleLoad();

            socket.on("GenerateClientReportMatrix", (finish, message, fileName, url, idEmployee, regCreationDate) => {

                dispatch(setLoadingDownloadRepot({
                    finish: finish,
                    message: message,
                    fileName: fileName,
                    url: url,
                    idEmployee: idEmployee,
                    regCreationDate: regCreationDate
                }))
            });


            socket.on("Percent", (percent) => {
                dispatch(setPercentDownloadReport(percent))
            })
        }

    }, [item, socket])


    return (
        <PersistGate loading={null} persistor={persistor}>
            <Layout>
                <HashRouter>
                    <Switch>
                        <Route exact path={'/'} component={isEdge ? BrowserMessageScreen : Login} />
                        <Route path={'/CommunicationStatus'} component={CommunicationStatusScreen} />
                        {isEdge ? <Route exact path={'/'} component={BrowserMessageScreen} /> :
                            Object.keys(authScreen).length > 0 ? authScreen.map(i => {
                                return <ProtectedRoute path={i.ActionUrl} component={components[i.ScreenName]} key={i.ScreenName} />
                            }) : <div>
                                <Route exact path={'/'} component={Login} />
                                <Route path='*' component={NotFoundScreen} />
                            </div>
                        }
                    </Switch>
                </HashRouter>
            </Layout>
        </PersistGate>
    );
}

                            // <ProtectedRoute path={'/CommunicationsViewer'} component={CommunicationsViewer} />
                            // <ProtectedRoute exact path={'/Dashboard'} component={DashboardScreen} />
                            // <ProtectedRoute path={'/EvaluationsScreen'} component={EvaluationsScreen} />
                            // <ProtectedRoute path={'/WorkCycle'} component={WorkCycleScreen} />
                            // <ProtectedRoute path={'/CommunicationProgramScreen'} component={CommunicationProgramScreen} />
                            // <ProtectedRoute path={'/EmployeeDashboard'} component={EmployeeDashboardScreen} />
                            // <ProtectedRoute component={NavMenu} />